import { render } from "./Loader3dot.vue?vue&type=template&id=3aaffa05&scoped=true"
import script from "./Loader3dot.vue?vue&type=script&lang=js"
export * from "./Loader3dot.vue?vue&type=script&lang=js"

import "./Loader3dot.vue?vue&type=style&index=0&id=3aaffa05&scoped=true&lang=scss"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aaffa05"]])

export default __exports__